import plural from 'pluralize';

/**
 * Pluralize helps you pluralize or singularize a word based on a number.
 * @param {string} word The word you want to pluralize or singularize.
 * @param {count} n The amount of things you need the word for.
 * @returns {string} Pluralized or singularized string
 */
export default function pluralize(word: any, n = 2): any {
  return plural(word, n);
}
